import "./scss/style.scss";
import LanguageManager from "./scripts/language-switcher";

document.addEventListener("DOMContentLoaded", () => {
	window.languageManager = new LanguageManager();
});
